import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import { NetworksModal } from '@/components/modals/NetworksModal';
import { removeUrlParameters } from '@/helpers/common';
import { MODAL_SEARCH_PARAM } from '@/helpers/variables';

const NETWORKS_MODAL = 'networks';

export const useNetworksModal = () => {
  const searchParams = useSearchParams();
  const modalParam = searchParams.get(MODAL_SEARCH_PARAM);

  const [isOpenNetworks, setOpenNetworks] = useState(false);

  useEffect(() => {
    if (modalParam === NETWORKS_MODAL) {
      setOpenNetworks(true);
    }
  }, [modalParam]);

  return isOpenNetworks ? (
    <NetworksModal
      onClose={() => {
        setOpenNetworks(false);
        removeUrlParameters([MODAL_SEARCH_PARAM]);
      }}
    />
  ) : null;
};
